import React from 'react';
import { RouteProps } from 'react-router-dom';
import MainPageHeader from '../pages/_layout/_headers/MainPageHeader';
import { isComingSoon } from '../preview/previewAccess';

// Pre-launch mode: the coming-soon page brings its own minimal top bar, so the
// full site header (nav, cart, login) is suppressed entirely — unless this
// browser holds a preview pass. Evaluated at render time for that reason.
const getHeaders = (): RouteProps[] =>
	isComingSoon() ? [] : [{ path: '*', element: <MainPageHeader /> }];

export default getHeaders;
